export default __webpack_public_path__ + "static/media/painting29.3115c1d1.jpeg";